export default "__VITE_ASSET__BCajoVFh__"